import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-daily-users',
  templateUrl: './add-daily-users.component.html',
  styleUrls: ['./add-daily-users.component.scss']
})
export class AddDailyUsersComponent implements OnInit {
formData: any = {
   name_ar: '',
  name_en: '',
  description: '',
  icon: '',
  order: 0,
  is_active: true

};
   public arrCoupons: any[] = [];
  public lang : any

    public currentLang : string
errors: any = {}; // store validation errors

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private language : LanguageService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')
   this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});


                  this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  this.formData.image = file.name; // send only file name ✔
}


    cancel(): void {
      this.router.navigate(['/DAILY_USERS']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

 const payload = {
    name_ar: this.formData.name_ar,
    name_en: this.formData.name_en,
    description: this.formData.description,
    icon: this.formData.icon,
    order: this.formData.order,
    is_active: this.formData.is_active ? 1 : 0
  };

  this.apisService.addUsers(payload).subscribe({
   next: () => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تمت الإضافة بنجاح'
      : 'Added successfully'
  );

  this.router.navigate(['/DAILY_USERS']);
},

error: () => {
  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ أثناء الإضافة'
      : 'Error adding'
  );
}

  });
}


}